import {FrameActions, PostMessageAction} from '@mc/react-frame';

/**
 * Zpráva nastavení parametru.
 *
 * @ignore
 */
export interface PropertySetMessage<N extends string, V> {
    /**
     * Typ zprávy.
     */
    type: 'PROPERTY_SET';

    /**
     * Název parametru.
     */
    name: N;

    /**
     * Hodnota parametru.
     */
    value: V;
}

/**
 * Nastaví parametr.
 *
 * @param name - Název parametru.
 * @param value - Hodnota parametru.
 * @returns Akce.
 * @ignore
 */
export const setProperty = <N extends string, V>(name: N, value: V): PostMessageAction<PropertySetMessage<N, V>> =>
    FrameActions.postMessage({type: 'PROPERTY_SET', name, value});
